import { render, staticRenderFns } from "./RelatedPersonTypes.vue?vue&type=template&id=2fdccc8b&"
import script from "./RelatedPersonTypes.vue?vue&type=script&lang=js&"
export * from "./RelatedPersonTypes.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports